import BigNumber from 'bignumber.js';
import { create } from 'zustand';

import { Value } from '../types';

type InputState = {
  input: {
    value: Value;
    triggerPrice?: string | null;
  };
  setInput: (input: InputState['input']) => void;
};

export const useFromInput = create<InputState>((set) => ({
  input: {
    value: {
      usd: BigNumber(200),
      token: BigNumber(200),
    },
    triggerPrice: null,
  },
  setInput: (input) => set({ input }),
}));
